module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }